<!-- Compact UPI / name+token: values only, no repeated labels -->
<div
  *ngIf="isCompact"
  class="abacus-structured is-compact"
  [class.is-token-row]="compactSecondaryIsToken"
  [class.is-pair-card]="!compactSecondaryIsToken"
>
  <div class="abacus-structured-primary">{{ compactPrimary }}</div>
  <div
    *ngIf="compactSecondary"
    class="abacus-structured-secondary"
    [class.is-token]="compactSecondaryIsToken"
    [attr.title]="compactSecondaryIsToken ? compactSecondary : null"
  >
    {{ compactSecondary }}
  </div>
</div>

<div
  *ngIf="!isCompact"
  class="abacus-structured"
  [class.has-pairs]="hasPairs"
  [class.is-plain]="!hasPairs"
  [class.is-record]="isRecord"
  [class.is-panel]="isPanel"
>
  <div
    *ngFor="let line of lines; let i = index"
    class="abacus-structured-line"
    [class.is-pair]="line.kind === 'pair'"
    [class.is-plain-line]="line.kind === 'plain'"
    [class.is-title]="isTitleLine(line, i)"
  >
    <ng-container *ngIf="line.kind === 'pair'; else plainLine">
      <!-- Title row: show name only, no "NAME" label -->
      <ng-container *ngIf="isTitleLine(line, i); else normalPair">
        <span class="abacus-structured-val is-title-val">{{ line.value }}</span>
      </ng-container>
      <ng-template #normalPair>
        <span class="abacus-structured-key">{{ formatKey(line.key) }}</span>
        <span
          class="abacus-structured-val"
          [class.is-token]="isTokenLine(line)"
          [attr.title]="isTokenLine(line) ? line.value : null"
        >{{ line.value }}</span>
      </ng-template>
    </ng-container>
    <ng-template #plainLine>
      <span class="abacus-structured-val">{{ line.value }}</span>
    </ng-template>
  </div>
</div>
